import React, { useEffect, useState } from "react";
import { fetchPendingReservationForTable, createOrderFromReservation } from "../../../../../../../services/pos/reservation/reservationApi";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Button,
} from "@mui/material";

const ShowTableReservation = ({ tableId }) => {
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [convertLoadingId, setConvertLoadingId] = useState(null); // للحالة أثناء التحويل
  const [successMsg, setSuccessMsg] = useState(""); // رسالة النجاح

  useEffect(() => {
    if (!tableId) return;
    setLoading(true);
    fetchPendingReservationForTable(tableId)
      .then((res) => {
        console.log("📡 بيانات الحجز:", res);
        // ✅ لو الرد Array مباشرة
        setReservations(Array.isArray(res) ? res : []);
      })
      .catch(() => setReservations([]))
      .finally(() => setLoading(false));
  }, [tableId]);

  // دالة تحويل الحجز إلى طلب (يمكنك تعديلها حسب منطقك)
  const handleConvertToOrder = async (reservation) => {
    setConvertLoadingId(reservation.id);
    try {
      const result = await createOrderFromReservation(reservation.id);
      setSuccessMsg(`✅ تم تحويل الحجز رقم ${reservation.id} إلى طلب بنجاح!`);
      // يمكنك هنا تحديث الحالة أو إعادة تحميل الطلبات إذا لزم الأمر
      setTimeout(() => setSuccessMsg(""), 3500); // إخفاء الرسالة بعد 3.5 ثانية
    } catch (error) {
      alert(error.message || "❌ حدث خطأ أثناء تحويل الحجز إلى طلب.");
    } finally {
      setConvertLoadingId(null);
    }
  };

  return (
    <Box sx={{ my: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        حجوزات الطاولة
      </Typography>

      {successMsg && (
        <Box sx={{
          mb: 2,
          p: 2,
          bgcolor: "#e0ffe0",
          color: "#2e7d32",
          borderRadius: "8px",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "16px",
          boxShadow: 1,
        }}>
          {successMsg}
        </Box>
      )}

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
          <CircularProgress />
        </Box>
      ) : reservations.length === 0 ? (
        <Typography color="text.secondary" align="center" sx={{ my: 2 }}>
          لا توجد حجوزات معلقة لهذه الطاولة.
        </Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>الطاولة</TableCell>
                <TableCell>التاريخ</TableCell>
                <TableCell>الوقت</TableCell>
                <TableCell>عدد الأشخاص</TableCell>
                <TableCell>الحالة</TableCell>
                <TableCell>ملاحظات</TableCell>
                <TableCell>تحويل</TableCell> {/* عمود جديد للتحويل */}
              </TableRow>
            </TableHead>
            <TableBody>
              {reservations.map((r) => (
                <TableRow key={r.id}>
                  <TableCell>{r.table?.name || "-"}</TableCell>
                  <TableCell>{r.reservation_date}</TableCell>
                  <TableCell>
                    {(() => {
                      if (!r.reservation_time) return "-";
                      const [h, m] = r.reservation_time.split(":");
                      let hour = Number(h);
                      const ampm = hour >= 12 ? "م" : "ص";
                      hour = hour % 12 || 12;
                      return `${hour}:${m} ${ampm}`;
                    })()}
                  </TableCell>
                  <TableCell>{r.number_of_people}</TableCell>
                  <TableCell>
                    {r.status === "pending" ? "⏳ معلق" : r.status}
                  </TableCell>
                  <TableCell>
                    {r.note || "-"}
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      sx={{
                        fontSize: "13px",
                        px: 2,
                        py: 0.5,
                        borderRadius: "8px",
                      }}
                      onClick={() => handleConvertToOrder(r)}
                      disabled={convertLoadingId === r.id}
                    >
                      {convertLoadingId === r.id ? <CircularProgress size={18} /> : "تحويله إلى طلب"}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default ShowTableReservation;
